<template>
  <div class="weighting-simulation-container">
    <NewPonderation id="weighting" v-model="campaignModel" :disableIgnored="isCampaignV3OrMore(campaign)"/>
    <div class="buttons-group">
      <Button class="icon icon-left outline-white" icon="bi-arrow-return-left" :label="$t('app.campaign.result.ponderation.buttons.cancel')" @click="emit('close')"></Button>
      <Button class="icon icon-left outline-white" icon="bi-arrow-repeat" :label="$t('app.campaign.result.ponderation.buttons.reset')" @click="resetSimulation"></Button>
      <Button class="icon icon-left green" icon="bi-check2" :label="$t('app.campaign.result.ponderation.buttons.applySimulation')" @click="applySimulation"></Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import cloneDeep from "lodash/cloneDeep";

import NewPonderation from "../../../newCampaign/partials/NewPonderation.vue";
import Button from "@/components/global/Button.vue";
import { Campaign } from "@/types/campaign";

interface Props {
  campaign: Campaign;
}

interface Emits {
  (e: "simulateWeighting", value: Campaign): void;
  (e: "close"): void;
}

const { isCampaignV3OrMore } = useSkillsStore();

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

// Local deep copy for editing
const simulatedCampaign = ref<Campaign>(cloneDeep(props.campaign));

// Watch for prop changes to update local copy
const campaignModel = computed({
  get: () => {
    return simulatedCampaign.value;
  },
  set: (value: Campaign) => {
    simulatedCampaign.value = value;
  },
});

// Apply changes to parent
const applySimulation = () => {
  emit("simulateWeighting", cloneDeep(simulatedCampaign.value));
  emit("close");
};

// Reset to original value
const resetSimulation = () => {
  simulatedCampaign.value = cloneDeep(props.campaign);
};
</script>

<style scoped lang="scss">
.weighting-simulation-container {
  margin-top: 24px;

  #weighting {
    height: 400px;
  }

  .buttons-group {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin-top: 24px;
  }
}
</style>
